import PropTypes from "prop-types";
import Section from "components/residency/Section";
import Title from "components/residency/Title";
import Container from "components/residency/Container";
import Question from "components/residency/Question";
import styles from "components/residency/Questions.module.scss";
import ImageOrCloudfront from "helpers/ImageOrCloudfront";

export default function Questions({ faqs, image, imageAlt }) {
  return (
    <div className={styles.component}>
      <div className={styles.visual}>
        <ImageOrCloudfront
          image={image}
          className={styles.image}
          altName={imageAlt}
        />
      </div>
      <Section>
        <Container>
          <Title size="lg" align="center">
            FAQs
          </Title>
          <div className={styles.list}>
            {Object.entries(faqs).map(([key, value]) => (
              <Question key={key} question={key} answer={value} />
            ))}
          </div>
        </Container>
      </Section>
    </div>
  );
}

Questions.propTypes = {
  faqs: PropTypes.objectOf(PropTypes.string).isRequired,
  image: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  imageAlt: PropTypes.string.isRequired,
};
